import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import LearnMore from "@/components/LearnMore";
import RequestAccess from "@/components/RequestAccess";
import PageviewTracker from "@/components/PageviewTracker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <PageviewTracker />
      <Routes>
        <Route path="/learn-more" element={<LearnMore />} />
        <Route path="/request-access" element={<RequestAccess />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
